module.exports = __webpack_public_path__ + "45897a66cdddc3fd78c14b4d9da84f05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-circus.png
// module id = 3195
// module chunks = 0